import { Injectable } from '@angular/core';
import {
  LoginAuthWithCredentials,
  LoginOAuth,
  OauthAEMConfig,
  SwapAuthForAccessTokens
} from '../../models';
import { UtilMethodsHelperService } from './util-methods-helper.service';
@Injectable({
  providedIn: 'root'
})
export class UtilMethodsService extends UtilMethodsHelperService {
  isPingErrorAuthResponse(
    authResponse:
      | LoginOAuth
      | LoginAuthWithCredentials
      | SwapAuthForAccessTokens
  ): boolean {
    return !!(
      authResponse?.error?.error ||
      this.isPingErrorDetailMessage(authResponse) ||
      this.isPingErrors(authResponse)
    );
  }

  isPingErrors(
    authResponse:
      | LoginOAuth
      | LoginAuthWithCredentials
      | SwapAuthForAccessTokens
  ): boolean {
    return !!(
      authResponse?.code === 'access_denied' ||
      authResponse?.error?.code ||
      authResponse?.errors ||
      authResponse?.error
    );
  }

  isPingErrorDetailMessage(
    authResponse:
      | LoginOAuth
      | LoginAuthWithCredentials
      | SwapAuthForAccessTokens
  ): boolean {
    return !!(
      authResponse?.error?.details &&
      authResponse?.error?.details[0] &&
      authResponse?.error?.details[0]?.userMessage
    );
  }

  isPingInvalidRequest(
    authResponse:
      | LoginOAuth
      | LoginAuthWithCredentials
      | SwapAuthForAccessTokens
  ): boolean {
    return !!(
      authResponse?.error?.details &&
      authResponse?.error?.details[0] &&
      authResponse?.error?.details[0].code === 'invalid_request'
    );
  }

  isPingResourceNotFound(
    authResponse:
      | LoginOAuth
      | LoginAuthWithCredentials
      | SwapAuthForAccessTokens
  ): boolean {
    return !!(
      authResponse?.error?.code &&
      (authResponse?.error?.code === 'UNEXPECTED_ERROR' ||
        authResponse?.error?.code === 'RESOURCE_NOT_FOUND')
    );
  }

  resourceNotFoundErrorId(
    authResponse:
      | LoginOAuth
      | LoginAuthWithCredentials
      | SwapAuthForAccessTokens,
    redirectfulFlowId: string
  ): string {
    return redirectfulFlowId &&
      authResponse?.error?.code === 'RESOURCE_NOT_FOUND'
      ? 'REDIRECTFULL_' + authResponse?.error?.code
      : authResponse?.error?.code ?? '';
  }

  isPingValidationError(
    authResponse:
      | LoginOAuth
      | LoginAuthWithCredentials
      | SwapAuthForAccessTokens
  ): boolean {
    return !!(
      this.isValidationError(authResponse) &&
      authResponse.error &&
      authResponse.error.details &&
      authResponse.error.details[0]
    );
  }

  isAuthConfigAndRememberMeFlowWithPromptLogin(
    authConfig: OauthAEMConfig,
    rememberMeFlowWithPromptLogin: boolean | undefined
  ): boolean {
    return !!(
      authConfig.REMEMBERME_API_FLOW_ENABLE && rememberMeFlowWithPromptLogin
    );
  }

  isAuthErrorResponseHelper(
    isAuthError: boolean,
    isAuthDetailUserMessage: boolean,
    isAuthDetailCode: boolean,
    isAuthErrorCode: boolean,
    authResponseCode: string | undefined,
    isResourceNotFound: boolean
  ): boolean {
    const t = isAuthError || isAuthDetailUserMessage || isAuthDetailCode;
    return (
      t ||
      this.isAuthErrorResponseHelperSupport(
        isAuthErrorCode,
        authResponseCode,
        isResourceNotFound
      )
    );
  }

  getAuthResponseErrorDetails(
    authResponse:
      | LoginOAuth
      | LoginAuthWithCredentials
      | SwapAuthForAccessTokens
  ) {
    return authResponse.error && authResponse.error.details
      ? authResponse.error.details[0]
      : {};
  }
}
